import { Routes, Route, Link } from "react-router-dom";
import { useState, useEffect } from "react";
import Home from "./pages/Home";
import ComicDetail from "./pages/ComicDetail";
import Reader from "./pages/Reader";

function App() {
  const [theme, setTheme] = useState("light");

  useEffect(() => {
    // Check system preference or saved theme could go here
    document.body.setAttribute("data-theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => (prev === "light" ? "dark" : "light"));
  };

  return (
    <div className="app">
      <nav className="navbar">
        <Link to="/">
          <h1>Mrtoon</h1>
        </Link>
        <button onClick={toggleTheme} className="theme-toggle">
          {theme === "light" ? "🌙 Dark" : "☀️ Light"}
        </button>
      </nav>

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/comic/:id" element={<ComicDetail />} />
        <Route path="/read/:id" element={<Reader />} />
      </Routes>
    </div>
  );
}

export default App;
